/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import ReactPaginate from 'react-paginate'

import Item from './Item'
import Styles from './index.scss'

const Table = props => {
  const {
    qs,
    tab,
    invoices,
    countries,
    handleSort,
    invoiceStatus,
    handleOnCheck,
    handlePageChange,
    handleOpenFilter,
    openFilterType,
    openFilterStatus,
    openFilterCountry,
    openFilterPaymentMethod,
    checkedFilterStatus,
    checkedFilterType,
    checkedFilterCountry,
    checkedFilterPaymentMethod,
  } = props

  // -- variable for checking filter status checked or not -- //
  const filterStatus = {
    paid: checkedFilterStatus.filter(value => value === 'paid')[0],
    pending: checkedFilterStatus.filter(value => value === 'pending')[0],
    failed: checkedFilterStatus.filter(value => value === 'failed')[0],
  }

  // -- variable for checking filter type checked or not -- //
  const filterType = {
    upfront: checkedFilterType.filter(value => value === 'upfront')[0],
    settlement: checkedFilterType.filter(value => value === 'settlement')[0],
  }

  // -- variable for checking filter country checked or not -- //
  const filterCountry = {
    ID: checkedFilterCountry.filter(value => value === 'ID')[0],
    MY: checkedFilterCountry.filter(value => value === 'MY')[0],
    PH: checkedFilterCountry.filter(value => value === 'PH')[0],
    SG: checkedFilterCountry.filter(value => value === 'SG')[0],
  }

  const filterPaymentMethod = {
    manualTransfer: checkedFilterPaymentMethod.find(value => value === 'manual_transfer'),
    creditCard: checkedFilterPaymentMethod.find(value => value === 'credit_card'),
    vaBca: checkedFilterPaymentMethod.find(value => value === 'id_credit_transfer_bca'),
    vaBni: checkedFilterPaymentMethod.find(value => value === 'id_credit_transfer_bni'),
  }

  return (
    <div>
      <div className="portlet-body">
        <div
          className="table-scrollable table-scrollable-borderless"
          style={{ padding: '0px 10px' }}
        >
          {/* Table of Invoices */}
          <table className="table table-hover table-light">
            <thead>
              <tr>
                {/* Condition for pending tab */
                tab === 1 && (
                  <th>
                    <input type="checkbox" />
                  </th>
                )
                /* ---- */
                }
                <th role="button" onClick={() => handleSort('createdAt')}>
                  <button
                    style={{
                      backgroundColor: 'transparent',
                      border: 'none',
                      outline: 'none',
                      padding: '0px',
                    }}
                  >
                    Invoice Date
                  </button>
                  <i style={{ marginLeft: '5px' }} className="fa fa-sort" />
                </th>
                {/* Condition for all payment tab */
                tab === 0 && (
                  <th>
                    <div role="button" onClick={() => handleOpenFilter('status')}>
                      <button
                        style={{
                          backgroundColor: 'transparent',
                          border: 'none',
                          outline: 'none',
                          padding: '0px',
                        }}
                      >
                        Status
                      </button>
                      <i style={{ marginLeft: '5px' }} className="fa fa-filter" />
                    </div>
                    {/* Status filter box */
                    openFilterStatus && (
                      <div className={Styles.filterBox}>
                        <div className={Styles.labelFilter}>
                          <span>Filter by Status</span>
                        </div>
                        <div className={Styles.filter}>
                          <div style={{ margin: '10px 0px' }}>
                            <span>Paid</span>
                            <input
                              type="checkbox"
                              style={{ float: 'right', cursor: 'pointer' }}
                              onChange={event => handleOnCheck(event, 'paid', 'status')}
                              checked={filterStatus.paid ? filterStatus.paid : false}
                            />
                          </div>
                          <div style={{ margin: '10px 0px' }}>
                            <span>Pending Approval</span>
                            <input
                              type="checkbox"
                              style={{ float: 'right', cursor: 'pointer' }}
                              onChange={event =>
                                handleOnCheck(event, 'pending', 'status')
                              }
                              checked={
                                filterStatus.pending ? filterStatus.pending : false
                              }
                            />
                          </div>
                          <div style={{ margin: '10px 0px' }}>
                            <span>Failed</span>
                            <input
                              type="checkbox"
                              style={{ float: 'right', cursor: 'pointer' }}
                              onChange={event => handleOnCheck(event, 'failed', 'status')}
                              checked={filterStatus.failed ? filterStatus.failed : false}
                            />
                          </div>
                        </div>
                      </div>
                    )
                    /* ---- */
                    }
                  </th>
                )
                /* ---- */
                }
                <th>
                  <span>Profile ID </span>
                </th>
                <th>
                  <div role="button" onClick={() => handleOpenFilter('country')}>
                    <button
                      style={{
                        backgroundColor: 'transparent',
                        border: 'none',
                        outline: 'none',
                        padding: '0px',
                      }}
                    >
                      Country
                    </button>
                    <i style={{ marginLeft: '5px' }} className="fa fa-filter" />
                    {/* Country filter box */
                    openFilterCountry && (
                      <div className={Styles.filterBox}>
                        <div className={Styles.labelFilter}>
                          <span>Filter by Country</span>
                        </div>
                        <div className={Styles.filter}>
                          <div style={{ margin: '10px 0px' }}>
                            <span>ID</span>
                            <input
                              type="checkbox"
                              style={{ float: 'right', cursor: 'pointer' }}
                              onChange={event => handleOnCheck(event, 'ID', 'country')}
                              checked={filterCountry.ID ? filterCountry.ID : false}
                            />
                          </div>
                          <div style={{ margin: '10px 0px' }}>
                            <span>MY</span>
                            <input
                              type="checkbox"
                              style={{ float: 'right', cursor: 'pointer' }}
                              onChange={event => handleOnCheck(event, 'MY', 'country')}
                              checked={filterCountry.MY ? filterCountry.MY : false}
                            />
                          </div>
                          <div style={{ margin: '10px 0px' }}>
                            <span>PH</span>
                            <input
                              type="checkbox"
                              style={{ float: 'right', cursor: 'pointer' }}
                              onChange={event => handleOnCheck(event, 'PH', 'country')}
                              checked={filterCountry.PH ? filterCountry.PH : false}
                            />
                          </div>
                          <div style={{ margin: '10px 0px' }}>
                            <span>SG</span>
                            <input
                              type="checkbox"
                              style={{ float: 'right', cursor: 'pointer' }}
                              onChange={event => handleOnCheck(event, 'SG', 'country')}
                              checked={filterCountry.SG ? filterCountry.SG : false}
                            />
                          </div>
                        </div>
                      </div>
                    )
                    /* ---- */
                    }
                  </div>
                </th>
                <th>
                  <span>Project Name </span>
                </th>
                <th>
                  <span>Invoice Number </span>
                </th>
                <th>
                  <div role="button" onClick={() => handleOpenFilter('payment')}>
                    <button
                      style={{
                        backgroundColor: 'transparent',
                        border: 'none',
                        outline: 'none',
                        padding: '0px',
                      }}
                    >
                      Payment Method
                    </button>
                    <i style={{ marginLeft: '5px' }} className="fa fa-filter" />
                    {/* Payment filter box */
                    openFilterPaymentMethod && (
                      <div className={`${Styles.filterBox} ${Styles.filterBoxPayment} `}>
                        <div className={Styles.labelFilter}>
                          <span>Filter by Payment method</span>
                        </div>
                        <div className={Styles.filter}>
                          <span>Manual transfer</span>
                          <input
                            type="checkbox"
                            style={{ float: 'right', cursor: 'pointer' }}
                            onChange={event =>
                              handleOnCheck(event, 'manual_transfer', 'payment')
                            }
                            checked={
                              filterPaymentMethod.manualTransfer
                                ? filterPaymentMethod.manualTransfer
                                : false
                            }
                          />
                        </div>
                        <div className={Styles.filter}>
                          <span>Credit card</span>
                          <input
                            type="checkbox"
                            style={{ float: 'right', cursor: 'pointer' }}
                            onChange={event =>
                              handleOnCheck(event, 'credit_card', 'payment')
                            }
                            checked={
                              filterPaymentMethod.creditCard
                                ? filterPaymentMethod.creditCard
                                : false
                            }
                          />
                        </div>
                        <div className={Styles.filter}>
                          <span>Virtual Account BCA</span>
                          <input
                            type="checkbox"
                            style={{ float: 'right', cursor: 'pointer' }}
                            onChange={event =>
                              handleOnCheck(event, 'id_credit_transfer_bca', 'payment')
                            }
                            checked={
                              filterPaymentMethod.vaBca
                                ? filterPaymentMethod.vaBca
                                : false
                            }
                          />
                        </div>
                        <div className={Styles.filter}>
                          <span>Virtual Account BNI</span>
                          <input
                            type="checkbox"
                            style={{ float: 'right', cursor: 'pointer' }}
                            onChange={event =>
                              handleOnCheck(event, 'id_credit_transfer_bni', 'payment')
                            }
                            checked={
                              filterPaymentMethod.vaBni
                                ? filterPaymentMethod.vaBni
                                : false
                            }
                          />
                        </div>
                      </div>
                    )
                    /* ---- */
                    }
                  </div>
                </th>
                <th role="button" onClick={() => handleSort('dueDate')}>
                  <button
                    style={{
                      backgroundColor: 'transparent',
                      border: 'none',
                      outline: 'none',
                      padding: '0px',
                    }}
                  >
                    Transaction Date
                  </button>
                  <i style={{ marginLeft: '5px' }} className="fa fa-sort" />
                </th>
                <th role="button" onClick={() => handleSort('deadlineDate')}>
                  <button
                    style={{
                      backgroundColor: 'transparent',
                      border: 'none',
                      outline: 'none',
                      padding: '0px',
                    }}
                  >
                    Paid Date
                  </button>
                  <i style={{ marginLeft: '5px' }} className="fa fa-sort" />
                </th>
                <th>
                  <div role="button" onClick={() => handleOpenFilter('type')}>
                    <button
                      style={{
                        backgroundColor: 'transparent',
                        border: 'none',
                        outline: 'none',
                        padding: '0px',
                      }}
                    >
                      Invoice Type
                    </button>
                    <i style={{ marginLeft: '5px' }} className="fa fa-filter" />
                  </div>
                  {/* Type filter box */
                  openFilterType && (
                    <div className={Styles.filterBox}>
                      <div className={Styles.labelFilter}>
                        <span>Filter by Invoice type</span>
                      </div>
                      <div className={Styles.filter}>
                        <div style={{ margin: '10px 0px' }}>
                          <span>upfront</span>
                          <input
                            type="checkbox"
                            style={{ float: 'right', cursor: 'pointer' }}
                            onChange={event => handleOnCheck(event, 'upfront', 'type')}
                            checked={filterType.upfront ? filterType.upfront : false}
                          />
                        </div>
                        <div style={{ margin: '10px 0px' }}>
                          <span>settlement</span>
                          <input
                            type="checkbox"
                            style={{ float: 'right', cursor: 'pointer' }}
                            onChange={event => handleOnCheck(event, 'settlement', 'type')}
                            checked={
                              filterType.settlement ? filterType.settlement : false
                            }
                          />
                        </div>
                      </div>
                    </div>
                  )
                  /* ---- */
                  }
                </th>
                <th>
                  <span>Invoice Amount</span>
                </th>
                {tab === 1 && <th> Action </th> /* Condition for pending tab */}
              </tr>
            </thead>
            <tbody>
              {/* Table Data */
              // -- To find out whether the data is available or not -- //
              invoices.rows && invoices.rows.length === 0 ? (
                <tr>{}</tr>
              ) : (
                invoices.rows &&
                invoices.rows.map((row, key) => (
                  <Item
                    indexKey={key}
                    key={row.id}
                    row={row}
                    skip={invoices.qs.skip}
                    invoiceStatus={invoiceStatus}
                    tab={tab}
                    countries={countries}
                  />
                ))
              )
              /* ---- */
              }
            </tbody>
          </table>
          {/* ---- */}
        </div>
      </div>
      <div className="portlet-footer">
        <div className="actions" style={{ display: 'flex', justifyContent: 'center' }}>
          <ReactPaginate
            previousLabel={'previous'}
            nextLabel={'next'}
            breakLabel={<a href="">...</a>}
            breakClassName={'break-me'}
            pageCount={invoices.totalPages}
            marginPagesDisplayed={3}
            pageRangeDisplayed={2}
            onPageChange={handlePageChange(qs)}
            containerClassName={'pagination'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
          />
        </div>
      </div>
    </div>
  )
}

Table.defaultProps = {
  invoices: {
    rows: [{}],
    qs: {
      skip: 0,
    },
    totalPages: 0,
  },
}

Table.propTypes = {
  tab: PropTypes.number.isRequired,
  invoices: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.object),
    qs: PropTypes.shape({
      skip: PropTypes.number,
    }),
    totalPages: PropTypes.number,
  }),
  invoiceStatus: PropTypes.shape({
    pending: PropTypes.shape({
      status: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired,
    paid: PropTypes.shape({
      status: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired,
    failed: PropTypes.shape({
      status: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  handlePageChange: PropTypes.func.isRequired,
  qs: PropTypes.shape({}).isRequired,
  handleSort: PropTypes.func.isRequired,
  handleOpenFilter: PropTypes.func.isRequired,
  openFilterStatus: PropTypes.bool.isRequired,
  openFilterType: PropTypes.bool.isRequired,
  openFilterCountry: PropTypes.bool.isRequired,
  countries: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleOnCheck: PropTypes.func.isRequired,
  checkedFilterStatus: PropTypes.arrayOf(PropTypes.string).isRequired,
  checkedFilterType: PropTypes.arrayOf(PropTypes.string).isRequired,
  checkedFilterCountry: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default Table
